import React from "react"
import types from "prop-types"
import { CheckmarkCircleIcon } from "shared/icons"

const ConversationListItemClosed = ({ closed }) => (
  closed
    ? <CheckmarkCircleIcon className="w-5 h-5 shrink-0" />
    : <div className="w-5 h-5 shrink-0 border rounded-full" />
)

ConversationListItemClosed.propTypes = {
  closed: types.bool.isRequired,
}

export default ConversationListItemClosed
